export default __webpack_public_path__ + "static/assets/images/default-classroom.dae58a0d03593885a815616c8db37998.png";